import { OrganizationKeyName } from "../../../model/Organization";
import { AdminErrorListResponseData } from "../../../service/api-response/AdminFormErrorResponse";

export const UPSERT_ORGANIZATION_FAIL = "ORGANIZATION:UPSERT_ORGANIZATION_FAIL";

export const upsertOrganizationFailAction = (
  errors: AdminErrorListResponseData,
  organizationKeyName?: OrganizationKeyName
) => ({
  type: UPSERT_ORGANIZATION_FAIL as typeof UPSERT_ORGANIZATION_FAIL,
  errors,
  organizationKeyName,
});

export type UpsertOrganizationFailAction = ReturnType<
  typeof upsertOrganizationFailAction
>;
